import AnalisaBarangJadiSPK from './FormAnalisaBarangJadi'

export default AnalisaBarangJadiSPK